import React from "react";
import { Outlet } from "react-router-dom";
import { useJsApiLoader } from "@react-google-maps/api";

const libraries = ["places"];
const key = "AIzaSyCrX4s2Y_jbtM-YZOmUwWK9m-WvlCu7EXA";

// The app's pages expect window.google.maps to exist when they render, so they wait for it here,
// as they did under <LoadScript>. The public marketing pages sit outside this gate and don't load Maps.
const GoogleMapsGate = () => {
  const { isLoaded, loadError } = useJsApiLoader({ googleMapsApiKey: key, libraries });

  if (loadError) return <div>Couldn't load Google Maps. Please refresh the page.</div>;
  if (!isLoaded) return <div>Loading...</div>;
  return <Outlet />;
};

export default GoogleMapsGate;
